import React from "react";
import ReactApexChart from "react-apexcharts";

const BarChart = ({
    series,
    categories
}) => {
    const state = {
        series: series,
        options: {
            chart: {
                type: 'bar',
                height: 350,
                stacked: true,
                toolbar: {
                    show: false
                },
                zoom: {
                    enabled: false
                }
            },
            responsive: [{
                options: {
                    legend: {
                        position: 'bottom',
                        offsetX: -10,
                        offsetY: 0
                    }
                }
            }],
            dataLabels: {
                enabled: false // Move this inside plotOptions.bar
            },
            plotOptions: {
                bar: {
                    horizontal: false,
                    borderRadius: 0,
                    columnWidth: '10%'
                },
            },
            xaxis: {
                type: 'category',
                categories: categories,
            },
            colors: ['#A8C3FF','#4870C9'],
            fill: {
                opacity: 1
            }
        },
    };

    return (
        <div>
            <div id="chart">
                <ReactApexChart options={state.options} series={state.series} type="bar" height={350} />
            </div>
            <div id="html-dist"></div>
        </div>
    );
}

export default BarChart;
